module.exports = __webpack_public_path__ + "img/step10.5.c23af88e.png";